<template>
  <div style="display: none"></div>
</template>

<script>
import * as signalR from "@microsoft/signalr";
import { mapState } from "vuex";

export default {
  name: "AiChatConnection",

  data() {
    return {
      connection: null,
      isConnected: false,
    };
  },

  computed: {
    ...mapState("user", ["userLogged"]),
  },

  mounted() {
    this.connect();
  },

  beforeDestroy() {
    if (this.connection) {
      this.connection.stop();
    }
  },

  methods: {
    connect() {
      const url = process.env.VUE_APP_API_URL;

      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${url}signalr-ai`)
        .withAutomaticReconnect()
        .build();

      this.connection.on("ReceiveAiMessage", (text) => {
        this.$emit("message", text);
      });

      this.connection
        .start()
        .then(() => {
          this.isConnected = true;
          this.$emit("connected");
        })
        .catch(() => {
          this.isConnected = false;
          this.$emit("disconnected");
        });

      this.connection.onreconnected(() => {
        this.isConnected = true;
        this.$emit("connected");
      });

      this.connection.onreconnecting(() => {
        this.isConnected = false;
        this.$emit("disconnected");
      });

      this.connection.onclose(() => {
        this.isConnected = false;
        this.$emit("disconnected");
      });
    },

    async send(text) {
      if (!text || !text.trim()) return;

      if (this.isConnected) {
        try {
          await this.connection.invoke(
            "SendAiMessage",
            this.userLogged.companyId,
            this.userLogged.user.id,
            text
          );
          return;
        } catch {
          }
      }

      this.mockResponse(text);
    },

    mockResponse(q) {
      const t = q.toLowerCase();
      let r = "";

      if (t.includes("onde está") || t.includes("produto")) {
        r = `Localização atual do produto solicitado:<br>
• Cliente <b>Studio X</b><br>
• Última movimentação: <b>retornou ao estoque</b> hoje às 09:12`;
      } else if (t.includes("contas") || t.includes("pagar")) {
        r = `Hoje você tem 3 contas a pagar:<br>
• Energia — R$ 620,00<br>
• Internet — R$ 159,00<br>
• Assinatura Nixloc — R$ 299,00`;
      } else if (t.includes("entrega")) {
        r = `Entregas de hoje:<br>
• Kit Iluminação — Cliente Audiomap<br>
• Projetor 5K — Light Vision`;
      } else if (t.includes("alterou") || t.includes("4829")) {
        r = `A última alteração da locação <b>#4829</b> foi feita por <b>Márcio</b> às 14:33.`;
      } else {
        r = `Olá! Sou a Nixia 🤖<br>Ainda estou em desenvolvimento, mas já consigo ajudar com o fluxo do Nixloc!`;
      }

      setTimeout(() => {
        this.$emit("message", r);
      }, 900);
    },
  },
};
</script>
